import React from "react";
import { LocalizationProvider as MuiXLocalizationProvider} from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { enUS } from "date-fns/locale/en-US";

function LocalizationProvider(props) {
  return (
    <MuiXLocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={enUS}
      {...props}
    />
  );
}

export * from "date-fns";
export { LocalizationProvider };
